import axios from 'axios'


export default {
    getArticle(){
        return axios.get('/article?is_active=1')
            .then(response => {
                return response.data
            })
    },
    getArticleDataSource(params){
        return axios.get('/article/datasource', {params})
            .then(response => {
                return response.data
            })
    },
    getArticlebyID(id){
        return axios.get('/article/' + id)
            .then(response => {
                return response.data
            })
    }, 
    getArticleWebView(id){
        return axios.get('/article/' + id + "/webview")
            .then(response => {
                return response.data
            })
    },       
    createArticle(formdata){
        return axios.post('/article', formdata)
            .then(response => {
                return response.data
            })
    },
    updateArticle(id,formdata){
        return axios.post('/article/' + id + '/update', formdata  )
            .then(response => {
                return response.data
            })
    },
    publishArticle(id){
        return axios.put('/article/' + id + '/publish')
            .then(response => {
                return response.data
            }) 
    },
    unpublishArticle(id){
        return axios.put('/article/' + id + '/unpublish')
            .then(response => {
                return response.data
            })
    },
    deactivateArticle(id){
        return axios.put('/article/' + id + '/deactivate')
            .then(response => {
                return response.data
            })
    },
    reactivateArticle(id){
        return axios.put('/article/' + id + '/reactivate')
            .then(response => {
                return response.data
            })
    },
    destroyArticle(id){
        return axios.delete('/article/' + id)
            .then(response => {
                return response.data
            })
    },
    updateBGImage(id,formData){
        return axios.post('/article/' + id + '/update_bgimage', formData)
            .then(response => {
                return response.data
            })
    },
    
}